// import Icon from '@ant-design/icons-vue'
import * as antDesign from 'ant-design-vue'
// ant-design-vue 4.x uses CSS-in-JS, no global CSS import needed
import { App } from 'vue'
import svgIcon from '/@/components/svgIcon.vue'

export const antComponents = {
  install (app: App): void {
    app.use(antDesign)
    // app.component('Icon', Icon)
    app.component('svg-icon', svgIcon)
  }
}
